import {
  Col,
  Container,
  Row
} from 'react-bootstrap';
import CollegeRentersInsurance from '../components/CollegeRentersInsurance';
import Wrapper from '../components/Wrapper';
import Logo from '../components/Logo';
import { useRouteMatch } from 'react-router-dom';

export const IndexPage = () => {
  const { params } = useRouteMatch();
  const trackingCodes = 'old-renters-widget';
  console.log(params);
  const schoolID = params.schoolID; // optional
  const url = typeof schoolID === 'string' && schoolID.trim().length > 0
    ? `https://gradguard.com/renters/enroll?school_id=${schoolID.trim()}&tracking_codes=${trackingCodes}`
    : `https://gradguard.com/renters/enroll?tracking_codes=${trackingCodes}`;
  return (
    <Wrapper>
       <Container className="styledContainer">
       <Logo />
        <Row>
          <Col>
            <CollegeRentersInsurance />
            <Row className='pb-2 justify-content-center'>
              <Col className='text-center'>
                  <a
                    className='btn btn-primary'
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Purchase Coverage
                  </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
}
